// extracted by mini-css-extract-plugin
export var card = "_m0-0";
export var content = "_m0-2";
export var details = "_m0-3";
export var icon = "_m0-1";
export var iconBlue = "_m0-5";
export var iconBrand = "_m0-4";
export var iconGrayBlue = "_m0-6";
export var iconGreen = "_m0-7";
export var iconIndigo = "_m0-8";
export var iconOrange = "_m0-9";
export var iconPurple = "_m0-a";
export var iconRed = "_m0-b";
export var iconWarning = "_m0-c";